// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3WDtP","log":"ModalInventoryLogs_log__3Zm7u","date":"ModalInventoryLogs_date__3YDLx","userName":"ModalInventoryLogs_userName__gNeaw"};